import * as React from "react";
import RedwingLogo from "../../../../resources/images/logo-512.png";

export const Logo = () => {
  return <img src={RedwingLogo} alt="Redwing" style={{ height: 104 }} />;
};
